import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { IonButton, IonIcon } from "@ionic/vue";

import { BUTTON_TYPE, ION_ROUTER_DIRECTION, ION_VARIANT } from "@/types/enum/ionicEnum";
import { IonButtonProps } from "@/types/props";


export default /*@__PURE__*/_defineComponent({
  __name: 'ButtonDelete',
  props: {
    buttonType: { default: BUTTON_TYPE.BUTTON },
    color: { default: ION_VARIANT.TRANSPARENT },
    disabled: { type: Boolean, default: false },
    download: {},
    expand: {},
    fill: {},
    href: {},
    mode: {},
    rel: {},
    routerAnimation: {},
    routerDirection: { default: ION_ROUTER_DIRECTION.FORWARD },
    shape: {},
    size: {},
    strong: { type: Boolean, default: false },
    target: {},
    type: { default: BUTTON_TYPE.BUTTON },
    height: {},
    arrow: { type: Boolean },
    isShow: { type: Boolean }
  },
  setup(__props: any) {

const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonButton), {
    class: "delete-button",
    "button-type": props.buttonType,
    color: props.color,
    disabled: props.disabled,
    download: props.download,
    expand: props.expand,
    fill: props.fill,
    href: props.href,
    mode: props.mode,
    rel: props.rel,
    "router-animation": props.routerAnimation,
    "router-direction": props.routerDirection,
    shape: props.shape,
    size: props.size,
    strong: props.strong,
    target: props.target,
    type: props.type
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(IonIcon), { icon: "assets/icon/delete.svg" })
    ]),
    _: 1
  }, 8, ["button-type", "color", "disabled", "download", "expand", "fill", "href", "mode", "rel", "router-animation", "router-direction", "shape", "size", "strong", "target", "type"]))
}
}

})